import { Component, OnInit, Input } from '@angular/core';

import { camps } from '../../../models/models.generated';
import { TranslateService } from '@ngx-translate/core';


@Component({
    selector: 'app-days-variant-enrollment-item',
    templateUrl: './days-variant-enrollment-item.component.html',
    styleUrls: ['./days-variant-enrollment-item.component.scss'],
    standalone: false
})
export class DaysVariantEnrollmentItemComponent implements OnInit {

    @Input() public daysVariant: camps.CampEnrollmentSessionDaysVariantDetails;

    constructor(private translate : TranslateService) { }

    ngOnInit() {
    }

    public get percentOfCapacity(){
        let percent = this.daysVariant.soldCount * 100 / this.daysVariant.capacity;
        return percent;
    }

    public get nothingSold():boolean{
        return this.daysVariant.soldCount == 0;
    }

    getCapacity(){
        if(this.daysVariant.capacity || this.daysVariant.capacity == 0){
            return this.daysVariant.capacity;
        }

        return this.translate.instant("CampEnrollment.Unlimited");
    }
}
